<template>
  <div class="no-results-box" v-if="!loading">
    <p class="dynamic-results">
      {{ title }}
      {{
        $store.state.products.filtersInput.reactionFilters.length === 0
          ? "sager"
          : "sager, hvor der er meldt"
      }}
    </p>
    <h4
      class="dynamic-results"
      v-if="$store.state.products.filtersInput.reactionFilters.length > 0"
    >
      {{ getDisplayNames("reaction") }}
    </h4>
    <p v-if="$store.state.products.searchTerm" class="dynamic-results">
      {{ subTitle }}
    </p>
    <h4 v-if="$store.state.products.searchTerm" class="dynamic-results">
      "{{ $store.state.products.searchTerm }}"
    </h4>
    <p
      v-if="$store.state.products.filtersInput.categoryFilters.length > 0"
      class="dynamic-results"
    >
      under
      {{
        getDisplayNames("category").length > 1 ? "kategorierne" : "kategorien"
      }}
    </p>
    <h4
      class="dynamic-results"
      v-if="$store.state.products.filtersInput.categoryFilters.length > 0"
    >
      {{ getDisplayNames("category") }}
    </h4>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  methods: {
    getDisplayNames(type) {
      let names = [];
      let filters = [];
      let displayNames = [];
      if (type === "reaction") {
        names = this.$store.state.products.reactionNames;
        filters = this.parseStrings(
          this.$store.state.products.filtersInput.reactionFilters
        );
      } else if (type === "category") {
        names = this.$store.state.products.categoryNames;
        filters = this.parseStrings(
          this.$store.state.products.filtersInput.categoryFilters
        );
      }
      if (names.length > 0) {
        names.forEach((name) => {
          if (filters.length > 0) {
            filters.forEach((filter) => {
              if (filter === name.id) {
                if (!displayNames.includes(name.name_d)) {
                  displayNames.push(name.name_d);
                }
              }
            });
          }
        });
      }
      console.log(displayNames);
      return displayNames;
    },
    parseStrings(stringArray) {
      let numberArray = [];
      if (stringArray.length > 0) {
        stringArray.forEach((element) => {
          numberArray.push(Number(element));
          // The below has been left here in case it will be needed at a later point
          // if (element) {
          //   element.split(",").map((item) => numberArray.push(Number(item)));
          // }
        });
      }
      return numberArray;
    },
  },
};
</script>

<style lang="scss">
.no-results-box {
  background-color: var(--lightgreyopaque);
  margin-top: 20px;
  padding: 40px;
  border: 2px dashed var(--mediumgreen);
  p.dynamic-results {
    text-align: center;
    color: var(--deepgreen);
    margin-bottom: 10px;
  }
  h4.dynamic-results {
    text-align: center;
    color: var(--darkgrey);
    margin-bottom: 10px;
  }
}
</style>
